module.exports = __webpack_public_path__ + "img/logo.f9098bd1.png";